
import { Box } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { mailTemplateConstants } from '../../../../constants/formConstants/adminFormConstants';
import useDebounce from '../../../../hooks/useDebounce';
import { createMessageTempate, getMessageTemplateById, testTemplate, updateMessageTemplate } from '../../../../services/plansService';
import Button from '../../../commons/Button/Button';
import GenerateFormHook from '../../../commons/GenerateFormHook';
import PaperWrapper from '../../../commons/Paper/PaperWrapper';
import Text from '../../../commons/Text';

const MailTemplateForm = ({
    match,
    readOnly = false,
    offer_identifier,
    setShowSendTestMainBtn,
    showSendTestMainBtn
}) => {
    const { id } = match && match.params ? match.params : {};
    const { handleSubmit, reset, watch, setValue } = useFormContext()
    const { enqueueSnackbar } = useSnackbar();

    const auth = useSelector(state => state.auth)
    const [redirect, setRedirect] = React.useState(false);
    const [btnIsLoading, setBtnIsLoading] = React.useState(false)
    const [dataById, setDataById] = React.useState({});
    const [formConst, setFormConst] = React.useState(mailTemplateConstants(readOnly))
    const [sendFirstTestMail, setSendFirstTestMail] = React.useState(true)
    const history = useHistory()
    const emailTemplateNameWatcher = watch('email_template_name', '')
    const fromEmailWatcher = watch('from_email', '')
    const smsTemplateIdWatcher = watch('sms_template_id', '')
    const debouncedEmailTemplateName = useDebounce(emailTemplateNameWatcher);
    const debouncedFromEmailWatcher = useDebounce(fromEmailWatcher);
    const debouncedSmsTemplateId = useDebounce(smsTemplateIdWatcher)

    

    const redirectToDetailsPage = () => {
        history.goBack()
    }

    const handleFormSubmit = (data) => {
        delete data.toEmail;
        delete data.toPhone;
        data.var = (data.var === '0') ? null : 1
        data.offer_identifier = offer_identifier

        setBtnIsLoading(true);
        if (dataById.id) {
            updateMessageTemplate(dataById.id, data).then(() => {
                enqueueSnackbar('Mail template has been updated!', {
                    variant: 'success'
                })
                setBtnIsLoading(false);
            })
        } else {
            createMessageTempate(data).then(response => {
                redirectToDetailsPage()
                setBtnIsLoading(false);
                enqueueSnackbar('Mail template has been created!', {
                    variant: 'success'
                })
            })
        }
    }

    const handleVerifyTemplate = (data) => {
        if (!!data.toEmail || !!data.toPhone) {
            
            data.jwt = auth.admin.jwt
            data.toPhone = `+91${data.toPhone}`
    
            data.smsTemplate = data.sms_template || null
            data.emailTemplateName = data.email_template_name || null
            data.smsTemplateId = data.sms_template_id || null
            data.fromEmail = data.from_email || null
    
            delete data.sms_template
            delete data.email_template_name
            delete data.sms_template_id
            delete data.from_email
            delete data.var
            testTemplate(data).then(resp => {
                if (resp) {
                    if (resp.payload) {
                        enqueueSnackbar('Template is verified!', {
                            variant: 'success'
                        })
                        setSendFirstTestMail(false)
                    }
                    else {
                        enqueueSnackbar('Template has some errors!', {
                            variant: 'error'
                        })
                    }
                }
            })
        }
        else {
            enqueueSnackbar('Email or phone number is required to send verifiation mail or SMS', {
                variant: 'error'
            })
        }
    }

    const fetchDataByOfferIdentifier = () => {
        getMessageTemplateById(id).then((response) => {
            if (response) {
                reset({
                    ...response[0],
                    offer_identifier
                })
                if (response[0]) {
                    setDataById(response[0])
                    setShowSendTestMainBtn(true)
                }
            }
        });
    }

    React.useEffect(() => {
        if (!!offer_identifier && !!id) {
            fetchDataByOfferIdentifier()
        }
        else if (!id && !!offer_identifier) {
            reset({
                offer_identifier
            })
        }
    }, [offer_identifier, id])

    React.useEffect(() => {
        const newFormConst = formConst.map(eachConst => {
            if (['toEmail'].includes(eachConst.name)) {
                eachConst.readOnly = (!debouncedEmailTemplateName || debouncedEmailTemplateName.length === 0 || !debouncedFromEmailWatcher || debouncedFromEmailWatcher?.length === 0)
                if (eachConst.readOnly) {
                    setValue('toEmail', '')
                }
            }
            return eachConst
        })

        setFormConst(newFormConst)
    }, [debouncedEmailTemplateName, debouncedFromEmailWatcher])


    React.useEffect(() => {
        const newFormConst = formConst.map(eachConst => {
            if (['toPhone'].includes(eachConst.name)) {
                eachConst.readOnly = (!debouncedSmsTemplateId || debouncedSmsTemplateId.length === 0)
                if (eachConst.readOnly) {
                    setValue('toPhone', '')
                }
            }
            return eachConst
        })

        setFormConst(newFormConst)
    }, [debouncedSmsTemplateId])

    

    return (

        <PaperWrapper>
            <Text fontSize={20} fontWeight={600} margin='0 0 1rem 0'>Mail Template form:-</Text>
            <GenerateFormHook formConstant={formConst} />
            {
                !readOnly && <Button disabled={!dataById.id && sendFirstTestMail} isLoading={btnIsLoading} onClick={handleSubmit(handleFormSubmit)} variant='contained' color='primary'>{dataById.id ? "Save Changes" : "Add"}</Button>
            }
            <Button style={{ marginLeft: 16 }} onClick={handleSubmit(handleVerifyTemplate)} variant='contained' color='primary'>send verification email and SMS</Button>
            <Box mt={6}>
                <Text>Please check these variable names are included in template:-</Text>
                <ol>
                    <li>receiver_name</li>
                    <li>receiver_phone_number</li>
                    <li>offer_code</li>
                    <li>plan_name</li>
                </ol>
            </Box>
        </PaperWrapper>
    )
}

export default MailTemplateForm
